import styled, { css } from "styled-components"

import uniRunning from "images/character/uni_running-133x144.png"
import goldCoin from "images/character/gold_coin-66x68.png"
import shineEffect from "images/effect/shine_effect-16x22.png"

export default function AchievementProgressBar({ currAuth, minAuth, maxAuth }) {
  const paybackPosition = 236 * (minAuth / maxAuth)
  const completeRate = !isNaN((currAuth / maxAuth) * 100) ? (currAuth / maxAuth) * 100 : 0
  console.log(completeRate)
  return (
    <Block>
      <ProgressBar>
        <BarPoint position={0}>
          <BarPointPin />
          {paybackPosition >= 20 && <BarPointTxt>시작</BarPointTxt>}
        </BarPoint>
        <BarPoint position={paybackPosition}>
          <PaybackIconPosition>
            <PaybackIconWrapper>
              <PaybackIcon src={goldCoin} />
            </PaybackIconWrapper>
            <ShineIconWrapper>
              <PaybackIcon src={shineEffect} />
            </ShineIconWrapper>
          </PaybackIconPosition>
          <BarPointPin isGray={currAuth < minAuth} />
          <BarPointTxt>환급</BarPointTxt>
        </BarPoint>
        <BarPoint position={236}>
          <BarPointPin isGray={currAuth !== maxAuth} />
          {paybackPosition <= 215 && <BarPointTxt>완주</BarPointTxt>}
        </BarPoint>
        <ProgressBarLine width={completeRate} />
      </ProgressBar>
      <RunningIconBlock left={completeRate}>
        <RunningIcon src={uniRunning} />
      </RunningIconBlock>
      <TaskCountBlock>
        <CompleteNum>{currAuth}</CompleteNum>/<TotalTaskNum>{maxAuth}</TotalTaskNum>
      </TaskCountBlock>
    </Block>
  )
}

const Block = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`

const ProgressBar = styled.div`
  position: relative;
  width: calc(100vw * (242 / 375));
  height: calc(100vw * (6 / 375));
  background: #e8e8e8;
  border-radius: calc(100vw * (22 / 375));
`

const BarPoint = styled.div`
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  left: ${({ position }) => `calc(100vw * ((${position - 6}) / 375))`};
  top: calc(100vw * (-3 / 375));
`

const BarPointPin = styled.div`
  width: calc(100vw * (12 / 375));
  height: calc(100vw * (12 / 375));
  background-color: #ffcf19;
  border-radius: 100%;
  margin-bottom: calc(100vw * (7 / 375));
  ${({ isGray }) =>
    isGray &&
    css`
      background-color: #e8e8e8;
    `}
`

const BarPointTxt = styled.span`
  font-style: normal;
  font-weight: 500;
  font-size: calc(100vw * (12 / 375));
  color: #989898;
  white-space: nowrap;
`

const RunningIconBlock = styled.div`
  position: absolute;
  bottom: calc(100vw * (6 / 375));
  left: calc(100vw * (-20 / 375));
  width: calc(100vw * (48 / 375));
  height: calc(100vw * (44.21 / 375));
  z-index: 10;

  ${({ left }) =>
    left > 8.6 &&
    css`
      left: calc(${left}% - 100vw * (48 / 375));
    `}
`

const RunningIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`

const ProgressBarLine = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: ${({ width }) => width}%;
  height: calc(100vw * (6 / 375));
  background-color: #ffcf19;
  border-radius: calc(100vw * (22 / 375));
`

const TaskCountBlock = styled.div`
  flex: 0 1 auto;
  display: flex;
  align-items: flex-end;

  transform: translateY(30%);
`

const CompleteNum = styled.span`
  font-size: calc(100vw * (20 / 375));
  font-weight: 500;
  line-height: calc(100vw * (18.27 / 375));
  margin-right: calc(100vw * (2 / 375));
`

const TotalTaskNum = styled.span`
  font-size: calc(100vw * (14 / 375));
  color: #7f7f7f;
`

const PaybackIconPosition = styled.div`
  position: relative;
`
const PaybackIconWrapper = styled.div`
  position: absolute;
  top: calc(100vw * (-38 / 375));
  left: calc(100vw * (-16.5 / 375));
  width: calc(100vw * (33 / 375));
  height: calc(100vw * (34 / 375));
`
const ShineIconWrapper = styled.div`
  position: absolute;
  top: calc(100vw * (-42 / 375));
  right: calc(100vw * (-22 / 375));
  width: calc(100vw * (8 / 375));
  height: calc(100vw * (11 / 375));
`
const PaybackIcon = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`
